import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@headlessui/react';

interface GlobalLoadingProps {
  isOpen: boolean;
  message?: string;
}

export default function GlobalLoading({ isOpen, message }: GlobalLoadingProps) {
  const { t } = useTranslation(['common_ui']);
  const resolvedMessage = message ?? t('common_ui:processing');
  return (
    <Dialog open={isOpen} onClose={() => { }} className="relative z-50">
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="bg-bg-surface rounded-xl border border-border-subtle shadow-xl p-8 flex flex-col items-center space-y-4">
          {/* Loading Spinner */}
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>

          {/* Loading Message */}
          <div className="text-center">
            <p className="text-lg font-medium text-gray-50">{resolvedMessage}</p>
            <p className="text-sm text-gray-400 mt-1">{t('common_ui:processingHint')}</p>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}